/**
 * FJX · Carrito lateral v5.3 — tema PERF-FIX 22-SEP
 * - <fjx-cart-add>: agrega un producto sugerido con un toque
 * - <fjx-size-select>: cambia la talla sin borrar el producto (conserva propiedades y plan de venta)
 * - Flechas del carrusel (se ocultan cuando no hay mas productos hacia ese lado)
 * - El pie copia el margen lateral del contenido del carrito (queda alineado con productos y titulo)
 * - body.fjx-drawer-open mientras el carrito esta abierto (oculta widgets flotantes)
 * - Eventos GA4 en dataLayer con prefijo fjx_ (item_id = ID de variante, segun SOP-003)
 * - v5.3 (13-OCT): promo Body al 50% — la vista rapida abierta desde la promo muestra el precio rebajado
 */
(function () {
  if (window.__fjxCartLoaded) return;
  window.__fjxCartLoaded = true;

  var SECTIONS = 'cart-drawer,cart-bubble';

  function push(eventName, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (data) { for (var k in data) { if (Object.prototype.hasOwnProperty.call(data, k)) payload[k] = data[k]; } }
    window.dataLayer.push(payload);
  }

  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function renderSections(sections) {
    if (!sections) return;
    var drawer = document.getElementById('Cart-Drawer');
    if (drawer && sections['cart-drawer']) {
      var inner = parse(sections['cart-drawer']).querySelector('.cart-drawer');
      if (inner) drawer.innerHTML = inner.innerHTML;
    }
    var toggle = document.getElementById('cart-drawer-toggle');
    if (toggle && sections['cart-bubble']) {
      var current = toggle.querySelector('.thb-item-count');
      var next = parse(sections['cart-bubble']).querySelector('.thb-item-count');
      if (current && next) current.innerHTML = next.innerHTML;
    }
    alignFooter();
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addItems(items) {
    return postJSON(theme.routes.cart_add_url + '.js', { items: items, sections: SECTIONS, sections_url: window.location.pathname });
  }

  function flashError(el, message) {
    var msg = document.createElement('p');
    msg.className = 'fjx-inline-error';
    msg.setAttribute('role', 'alert');
    msg.textContent = message || 'No pudimos actualizar el carrito. Intenta de nuevo.';
    el.appendChild(msg);
    setTimeout(function () { msg.remove(); }, 4000);
  }

  function readJSON(str) {
    if (!str) return null;
    try { return JSON.parse(str); } catch (e) { return null; }
  }

  /* ---------- Pie alineado con el contenido ---------- */
  // El pie usa el mismo margen lateral que .side-panel-content (o el encabezado si no hay contenido).
  // Minimo 16 px para que nunca quede pegado al borde.
  function alignFooter() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.fjx-footer');
    if (!footer) return;
    var ref = drawer.querySelector('.side-panel-content') || drawer.querySelector('.side-panel-header');
    var left = 20, right = 20;
    if (ref) {
      var cs = window.getComputedStyle(ref);
      left = parseFloat(cs.paddingLeft) || 0;
      right = parseFloat(cs.paddingRight) || 0;
      if (left < 16) left = 20;
      if (right < 16) right = 20;
    }
    footer.style.paddingLeft = left + 'px';
    footer.style.paddingRight = right + 'px';
  }

  /* ---------- Agregar sugerido ---------- */
  if (!customElements.get('fjx-cart-add')) {
    customElements.define('fjx-cart-add', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        if (!this.button || this._bound) return;
        this._bound = true;
        this.button.addEventListener('click', this.onClick.bind(this));
      }
      onClick(e) {
        e.preventDefault();
        if (this.classList.contains('is-loading')) return;
        var self = this;
        var variantId = parseInt(this.dataset.variantId, 10);
        this.classList.add('is-loading');
        this.button.setAttribute('aria-disabled', 'true');
        addItems([{ id: variantId, quantity: 1 }])
          .then(function (res) {
            if (res.status) {
              self.classList.remove('is-loading');
              self.button.removeAttribute('aria-disabled');
              flashError(self.closest('.fjx-card') || self, res.description);
              return;
            }
            push('fjx_cart_upsell_add', {
              fjx_source: self.dataset.source,
              item_id: String(variantId),
              item_name: self.dataset.title,
              value: parseFloat(self.dataset.price) || 0,
              currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP'
            });
            renderSections(res.sections);
            if (typeof dispatchCustomEvent === 'function') {
              dispatchCustomEvent('cart:item-added', { product: res.items ? res.items[0] : res });
            }
          })
          .catch(function () {
            self.classList.remove('is-loading');
            self.button.removeAttribute('aria-disabled');
            flashError(self.closest('.fjx-card') || self);
          });
      }
    });
  }

  /* ---------- Cambiar talla ---------- */
  if (!customElements.get('fjx-size-select')) {
    customElements.define('fjx-size-select', class extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector('select');
        if (!this.select || this._bound) return;
        this._bound = true;
        this.initial = this.select.value;
        this.select.addEventListener('change', this.onChange.bind(this));
      }
      buildItem(id, qty) {
        var item = { id: parseInt(id, 10), quantity: qty };
        var props = readJSON(this.dataset.props);
        if (props && typeof props === 'object' && Object.keys(props).length) item.properties = props;
        var plan = parseInt(this.dataset.plan, 10);
        if (plan) item.selling_plan = plan;
        return item;
      }
      onChange(e) {
        e.stopPropagation();
        var self = this;
        var line = parseInt(this.dataset.line, 10);
        var qty = parseInt(this.dataset.qty, 10) || 1;
        var newId = this.select.value;
        var oldId = this.initial;
        if (String(newId) === String(oldId)) return;
        var row = this.closest('.product-cart-item');
        if (row) row.classList.add('thb-loading');
        this.select.disabled = true;

        postJSON(theme.routes.cart_change_url + '.js', { line: line, quantity: 0 })
          .then(function () { return addItems([self.buildItem(newId, qty)]); })
          .then(function (res) {
            if (res.status) {
              return addItems([self.buildItem(oldId, qty)]).then(function (back) {
                renderSections(back.sections);
                var host = document.querySelector('#Cart-Drawer .product-cart-item--container') || document.getElementById('Cart-Drawer');
                if (host) flashError(host, 'Esa talla no está disponible en este momento. Dejamos tu talla original.');
              });
            }
            push('fjx_cart_size_change', {
              item_id_from: String(oldId),
              item_id: String(newId),
              fjx_size_to: self.select.options[self.select.selectedIndex].dataset.size || ''
            });
            renderSections(res.sections);
          })
          .catch(function () {
            if (row) row.classList.remove('thb-loading');
            self.select.disabled = false;
            self.select.value = oldId;
            flashError(self);
          });
      }
    });
  }

  /* ---------- Flechas del carrusel ---------- */
  function updateArrows(track) {
    var wrap = track.closest('.fjx-upsell');
    if (!wrap) return;
    var prev = wrap.querySelector('.fjx-upsell__arrow--prev');
    var next = wrap.querySelector('.fjx-upsell__arrow--next');
    var max = track.scrollWidth - track.clientWidth - 2;
    wrap.classList.toggle('fjx-upsell--static', max <= 2);
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= max;
  }
  function updateAllArrows() {
    document.querySelectorAll('#Cart-Drawer .fjx-upsell__track').forEach(updateArrows);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.fjx-upsell__arrow');
    if (!btn) return;
    var track = btn.closest('.fjx-upsell').querySelector('.fjx-upsell__track');
    var card = track.querySelector('.fjx-card');
    var step = card ? card.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
    track.scrollBy({ left: btn.classList.contains('fjx-upsell__arrow--prev') ? -step : step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('fjx-upsell__track')) updateArrows(e.target);
  }, true);
  window.addEventListener('resize', function () { updateAllArrows(); alignFooter(); });

  /* ---------- Estado del carrito: abierto/cerrado y re-render ---------- */
  function watchDrawer() {
    var drawer = document.getElementById('Cart-Drawer');
    if (!drawer) return;
    var sync = function () {
      document.body.classList.toggle('fjx-drawer-open', !drawer.hasAttribute('inert'));
      alignFooter();
      requestAnimationFrame(updateAllArrows);
    };
    new MutationObserver(sync).observe(drawer, { attributes: true, attributeFilter: ['inert', 'class'], childList: true });
    sync();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawer);
  } else {
    watchDrawer();
  }

  /* ---------- Medicion ---------- */
  document.addEventListener('cart-drawer:open', function () {
    push('fjx_cart_open', {});
    alignFooter();
    requestAnimationFrame(updateAllArrows);
  });

  document.addEventListener('click', function (e) {
    var drawer = e.target.closest('#Cart-Drawer');
    if (!drawer) return;
    if (e.target.closest('.checkout-button')) {
      var total = drawer.querySelector('[data-fjx-cart-total]');
      push('fjx_cart_checkout_click', { value: total ? parseFloat(total.dataset.fjxCartTotal) : 0 });
    } else if (e.target.closest('quick-view[data-fjx-source]')) {
      var qv = e.target.closest('quick-view[data-fjx-source]');
      push('fjx_cart_upsell_view', { fjx_source: qv.dataset.fjxSource, fjx_handle: qv.dataset.productHandle });
    } else if (e.target.closest('.fjx-empty__tile')) {
      push('fjx_cart_empty_click', { fjx_handle: e.target.closest('.fjx-empty__tile').dataset.handle });
    }
  });

  /* ---------- Promo Body al 50%: precio rebajado en la vista rapida (13-OCT) ---------- */
  // Solo cuando la vista rapida se abre desde un boton de la promo (quick-view[data-fjx-source="body50"]).
  // Reescribe cada .price dentro de #Product-Drawer-Content y lo vuelve a hacer si el tema lo repinta
  // (cambio de color o talla). Es solo visual: el descuento real lo aplica Shopify en el carrito.
  var b50 = null;
  var b50Obs = null;

  function b50Format(text, pct) {
    var m = String(text).match(/\d[\d.,]*/);
    if (!m) return null;
    var raw = m[0];
    var sep = raw.indexOf(',') > -1 ? ',' : (raw.indexOf('.') > -1 ? '.' : '');
    var n = parseInt(raw.replace(/[^\d]/g, ''), 10);
    if (!n) return null;
    var promo = String(Math.round(n * (100 - pct) / 100));
    if (sep) promo = promo.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return String(text).replace(raw, promo);
  }

  function b50Apply() {
    if (!b50) return;
    var box = document.getElementById('Product-Drawer-Content');
    if (!box) return;
    if (!b50Obs) b50Obs = new MutationObserver(b50Apply);
    b50Obs.disconnect();
    box.querySelectorAll('.price').forEach(function (price) {
      if (price.querySelector('.fjx-b50-was')) return;
      var amount = price.querySelector('ins .amount') || price.querySelector('.amount');
      if (!amount) return;
      var original = amount.textContent.trim();
      var promo = b50Format(original, b50.pct);
      if (!promo) return;
      var oldDel = price.querySelector('del');
      if (oldDel) oldDel.remove();
      var holder = amount.closest('ins') || amount;
      var was = document.createElement('del');
      was.className = 'fjx-b50-was';
      was.textContent = original;
      holder.parentNode.insertBefore(was, holder);
      amount.textContent = promo;
      amount.classList.add('fjx-b50-now');
      var tag = document.createElement('span');
      tag.className = 'fjx-b50-tag';
      tag.textContent = b50.label;
      holder.parentNode.insertBefore(tag, holder.nextSibling);
    });
    b50Obs.observe(box, { childList: true, subtree: true, characterData: true });
  }

  function b50Stop() {
    b50 = null;
    if (b50Obs) b50Obs.disconnect();
  }

  document.addEventListener('click', function (e) {
    var qv = e.target.closest && e.target.closest('quick-view');
    if (!qv) return;
    if (qv.dataset.fjxSource === 'body50') {
      var pct = parseInt(qv.dataset.fjxPct, 10) || 50;
      var unlocked = qv.dataset.fjxUnlocked === 'true';
      b50 = {
        pct: pct,
        label: unlocked ? ('-' + pct + '% en tu carrito') : ('-' + pct + '% por compras superiores a ' + (qv.dataset.fjxMin || '$250.000'))
      };
      b50Apply();
    } else {
      b50Stop();
    }
  }, true);

  function watchProductDrawer() {
    var pd = document.getElementById('Product-Drawer');
    if (!pd) return;
    new MutationObserver(function () {
      if (pd.hasAttribute('inert')) b50Stop();
    }).observe(pd, { attributes: true, attributeFilter: ['inert'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchProductDrawer);
  } else {
    watchProductDrawer();
  }
})();
